import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('formulaEditor');
const type = createActionType('formulaEditor');

export const INITIALIZE_COLUMN_LIST = type('InitializeColumnList');
export const SET_COLUMN_LIST = type('SetColumnList');
export const REBASE_COLUMN_LIST = type('RebaseColumnList');
export const ADD_COLUMN = type('AddColumn');
export const SELECT_COLUMN = type('SelectColumn');
export const RENAME_COLUMN = type('RenameColumn');
export const REMOVE_COLUMN = type('RemoveColumn');
export const ENABLE_COLUMN_VISIBILITY = type('EnableColumnVisibility');
export const DISABLE_COLUMN_VISIBILITY = type('DisableColumnVisibility');
export const TOGGLE_ALL_COLUMNS_VISIBILITY = type('ToggleAllColumnsVisibility');

export const UPDATE_FORMULA = type('UpdateFormula');
export const CANCEL_FORMULA = type('CancelFormula');
export const APPLY_FORMULA = type('ApplyFormula');

export const CREATE_FORMULA_OPERATION = apiType('CreateFormulaOperation');
export const UPDATE_FORMULA_OPERATION = type('UpdateFormulaOperation');

export const VALIDATE_REMOVE_COLUMN = apiType('ValidateRemoveColumn');
export const VALIDATE_RENAME_COLUMN = apiType('ValidateRenameColumn');
export const VALIDATE_APPLY_FORMULA = apiType('ValidateApplyFormula');

export const RELOAD_PREVIEW = type('ReloadPreview');
export const SYNC_TO_INPUT_COLUMNS = type('SyncToInputColumns');
